<template>
  <div class="total-info" :class="className">
    <img class="total-info-img" :src="totalInfo.imgUrl" />
    <div class="total-list">
      <p class="total-p"><span class="text-title">大吉穿：</span><span class="text-color" :class="totalInfo.colorArr[0].colorClass">{{ totalInfo.colorArr[0].colorText }}</span></p>
      <p class="total-p"><span class="text-title">次吉穿：</span><span class="text-color" :class="totalInfo.colorArr[1].colorClass">{{ totalInfo.colorArr[1].colorText }}</span></p>
      <p class="total-p"><span class="text-title">第三穿：</span><span class="text-color" :class="totalInfo.colorArr[2].colorClass">{{ totalInfo.colorArr[2].colorText }}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalInfo',
  props: {
    className: {
      type: String,
      default() { return ''}
    },
    totalInfo: {
      type: Object,
      required: true,
      validator(value) {
        // Basic shape validation to help catch missing fields in Vue2
        const keys = ['imgUrl', 'colorArr'];
        return keys.every(k => Object.prototype.hasOwnProperty.call(value, k));
      }
    }
  }
}
</script>

<style scoped>
.total-info {
  width: 100%;
}
.total-info.solid { background: #FBF5EF; } /*土*/
.total-info.wood { background: #F8FFF5; } /*木*/
.total-info.fire { background: #FFF4F4; } /*火*/
.total-info.gold { background: #F8F8F8; } /*金*/
.total-info.water { background: #F6F8FE; } /*水*/

.total-info-img {
  width: 100%;
  /* height: 17rem; */
}
.total-list {
  width: 100%;
  padding: 0.5rem 0 1rem 1rem;
  overflow: hidden;
  white-space: nowrap;
  word-break: keep-all;
}
.total-p {
  font-size: 1rem;
}
.text-title {
  font-weight: 400;
  color: #191919;
}
.text-color {
  font-weight: 800;
}
.white { color: #999999; }
.yellow { color: #D99300; }
.green { color: #00B880; }
.red { color: #FA5959; }
.blue { color: #175CE5; }
.m-t-1 { margin-top: 1.5rem; }
.m-b-2 { margin-bottom: 2rem; }
</style>
